import React, { useContext, useEffect } from 'react';
import * as Styled from './styled';
import { TradingContext } from '@trader/contexts';
import { defaultIcon } from '@trader/constants';
import { observer } from 'mobx-react-lite';
import { useMst } from '@trader/store';
import { useI18next } from '@trader/services';

interface ISuccessChangeOrder {
  type: 'market' | 'limit';
  isClose?: boolean;
}

export const SuccessChangeOrder: React.FC<ISuccessChangeOrder> = observer(
  ({ type, isClose }) => {
    const store = useMst();
    const placedOrder = store.pages.trading.placedOrder;
    const { instrument } = useContext(TradingContext);
    const { translate } = useI18next();

    const volume = placedOrder?.volume;
    const price = placedOrder?.price;

    const title = isClose
      ? translate('COMMON.LABELS.POSITION_CLOSED')
      : type === 'market'
      ? translate('COMMON.LABELS.POSITION_OPENED')
      : translate('COMMON.LABELS.ORDER_OPENED');

    const subTitle = isClose
      ? translate(
          `COMMON.LABELS.STOP_${instrument.market.billType.toUpperCase()}`
        )
      : type === 'market'
      ? translate(
          `COMMON.LABELS.POSITION_OPENED_${instrument.market.billType.toUpperCase()}`
        )
      : translate(
          `COMMON.LABELS.ORDER_OPENED_${instrument.limit.billType.toUpperCase()}`
        );

    useEffect(() => {
      return () => {
        store.pages.trading.runInAction(() => {
          store.pages.trading.placedOrder = null;
        });
      };
    }, []);

    return (
      <Styled.Root>
        <Styled.Header>
          <Styled.Title>{title}</Styled.Title>
        </Styled.Header>
        <img
          src={instrument.general?.iconUrl || defaultIcon}
          alt='instrument icon'
          width={30}
          height={30}
        />
        <Styled.VolumeContainer>
          <Styled.Title>{subTitle}</Styled.Title>
          <Styled.Volume>{volume}</Styled.Volume>
        </Styled.VolumeContainer>

        <Styled.Instrument>{instrument.general.displayName}</Styled.Instrument>
        <Styled.Price>{price ? `@${price}` : ''}</Styled.Price>

        <Styled.Success>{translate('COMMON.LABELS.SUCCESS')}</Styled.Success>
      </Styled.Root>
    );
  }
);
